import 'swiper/css/swiper.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '../../index.css';
import '../../styles/main.scss';
import '../../tailwind.css';

const LazyLoadCSS = () => {
  return null;
};

export default LazyLoadCSS;
